import { updateListMethod } from '../../utils/list'
import {
  FEED_UPDATE_LIST,
    FEED_UPDATE_LIST_METHOD
} from '../actions/feed.actions'

const initialState = {
  list: [],
  totalList: 0
}
const feedReducer = (state = initialState, action) => {
  const newState = { ...state }
  const { type, payload } = action

  switch (type) {
    case FEED_UPDATE_LIST:
      newState.list = payload.data
      newState.totalList = payload.count
    break
    case FEED_UPDATE_LIST_METHOD:
      newState.list = updateListMethod(payload.method, payload.data, newState.list)
    break
    default:
      return state
  }

  return newState
}

export default feedReducer